module.exports = __webpack_public_path__ + "static/media/single.e8d14226.svg";